import React from 'react';
import { useAppRoute } from '../../../../hooks/app-route-hooks';
import { TimelineDetailPageContainer } from '../../../../components/TimelineDetailPageContainer';

export const OverviewSiteEventDetails: React.FC = () => {
    const currentAppRoute = useAppRoute('OverviewSiteEventDetails');
    return (
        <TimelineDetailPageContainer
            testId="overview-site-event-details"
            appRoute={{
                type: 'OverviewSite',
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            }}
        ></TimelineDetailPageContainer>
    );
};
